import React from "react";
import QRIcon from "../../../Assets/Images/QrCode.jpeg"
import { useSelector } from "react-redux";

const QRPayment = () => {

  const username = useSelector((state) => state.auth.employeeDetails?.username);
  const mobile_number = useSelector((state) => state.auth.employeeDetails?.mobile_number);
  return (
    <div className="p-6 m-2 bg-white flex flex-col items-center">
      <h1 className="text-2xl font-semibold">QR CODE</h1>

      <div className="mt-4 bg-green-100 text-green-700 p-3 text-center rounded w-3/4">
        Scan a QR code for fast, secure payments. 🚀
      </div>
      {username === "par4731_6252" && mobile_number === "8899996252" && (
        <div className="mt-10 w-full flex justify-center">
          <img src={QRIcon} alt="QR Code" className="w-full h-auto max-w-md" />
        </div>
      )}

    </div>
  );
};

export default QRPayment;
